module.exports = __webpack_public_path__ + "img/Banner640DailyMath.bb8d3a1b.png";